import { useEffect, useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import useMutationWithConfirmation from '../../../../../hooks/useMutationWithConfirmation';
import LoanService from '../../../../../services/LoanService';
import { useUiStore } from '../../../../../store';

export default function useInsurancesActions({ loanId, insurances, refetch }) {
  const navigate = useNavigate();

  const setIsFetching = useUiStore((state) => state.setIsFetching);

  const cantForcePlace = insurances?.some(
    (insurance) => insurance?.status === 'INFORCE'
  );

  const { confirm: forcePlace, isPending } = useMutationWithConfirmation({
    confirmationMessage:
      'Are you sure you want to force place insurance on this borrower?',
    successMessage: 'Success',
    mutationFn: () => LoanService.forcePlace(loanId),
    refetch,
    confirmButtonLabel: 'Yes',
    cancelButtonLabel: 'No, cancel',
  });

  useEffect(() => {
    if (isPending) {
      setIsFetching(true);
    } else {
      setIsFetching(false);
    }
  }, [isPending, setIsFetching]);

  const actions = useMemo(() => {
    return [
      {
        actionTitle: 'Add policy',
        actionDescription: 'Create a new insurance policy for this loan.',
        onClick: () => {
          navigate(`/loans/${loanId}/insurances/new?tab=Insurance`);
        },
      },
      {
        actionTitle: 'Force place',
        actionDescription: cantForcePlace
          ? 'Force place is only available when the loan has no policies in force.'
          : 'Force place insurance for this loan. This will notify our force place insurance provider and the borrower.',
        onClick: forcePlace,
        disabled: cantForcePlace || isPending,
      },
    ];
  }, [cantForcePlace, forcePlace, isPending, loanId, navigate]);

  return actions;
}
